// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InputPassword_wrapper__1JnkR","input":"InputPassword_input__12Im9","iconEye":"InputPassword_iconEye__3LgXF"};